// Mirrors the server resolver. This drives what the UI *shows*; it is never
// the thing that protects data. The API re-checks every call, because a
// hidden button is not a security control.
export function can(permissions, permission) {
  if (!permissions?.length) return false;
  if (permissions.includes("*")) return true;
  return permissions.includes(permission);
}

export function canAny(permissions, ...required) {
  return required.some((p) => can(permissions, p));
}

export const ROLE_LABELS = {
  SUPER_ADMIN: "Super admin",
  HR: "HR",
  MANAGER: "Manager",
  EMPLOYEE: "Employee",
};
